"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "ReviewCycleLogSearchServiceQueryParams", {
    enumerable: true,
    get: function() {
        return ReviewCycleLogSearchServiceQueryParams;
    }
});
const _zod = require("zod");
const _utilsisomorphic = require("@performyard/utils-isomorphic");
const _resourcelogs = require("../../resource-logs");
const _base = require("../base");
const ReviewCycleLogSearchServiceQueryParams = _base.BaseSearchServiceQueryParams.extend({
    service: _zod.z.literal("review_cycle_log"),
    resource_type_eq: _zod.z.union([
        _resourcelogs.AutoflowResourceType,
        _resourcelogs.ReviewCycleResourceType
    ]).optional(),
    resource_type_in: (0, _utilsisomorphic.transformStringToArray)(_zod.z.union([
        _resourcelogs.AutoflowResourceType,
        _resourcelogs.ReviewCycleResourceType
    ]).array().or(_zod.z.union([
        _resourcelogs.AutoflowResourceType,
        _resourcelogs.ReviewCycleResourceType
    ]))).optional(),
    change_type_eq: _resourcelogs.ResourceLogResourceChangeTypes.optional(),
    change_type_in: (0, _utilsisomorphic.transformStringToArray)(_resourcelogs.ResourceLogResourceChangeTypes.array().or(_resourcelogs.ResourceLogResourceChangeTypes)).optional(),
    change_type_nin: (0, _utilsisomorphic.transformStringToArray)(_resourcelogs.ResourceLogResourceChangeTypes.array().or(_resourcelogs.ResourceLogResourceChangeTypes)).optional(),
    changed_by_in: (0, _utilsisomorphic.transformStringToArray)(_utilsisomorphic.transformObjectId.array().or(_utilsisomorphic.transformObjectId)).optional(),
    changed_by_nin: (0, _utilsisomorphic.transformStringToArray)(_utilsisomorphic.transformObjectId.array().or(_utilsisomorphic.transformObjectId)).optional(),
    changed_by_name_re: _zod.z.string().optional(),
    changed_by_name_eq: _zod.z.string().optional(),
    changed_at_gt: _utilsisomorphic.transformDate.optional(),
    changed_at_lt: _utilsisomorphic.transformDate.optional(),
    subject_id_in: (0, _utilsisomorphic.transformStringToArray)(_utilsisomorphic.transformObjectId.array().or(_utilsisomorphic.transformObjectId)).optional(),
    subject_id_nin: (0, _utilsisomorphic.transformStringToArray)(_utilsisomorphic.transformObjectId.array().or(_utilsisomorphic.transformObjectId)).optional(),
    subject_name_re: _zod.z.string().optional(),
    subject_name_eq: _zod.z.string().optional(),
    resource_id_eq: _utilsisomorphic.transformObjectId.optional(),
    resource_id_in: (0, _utilsisomorphic.transformStringToArray)(_utilsisomorphic.transformObjectId.array().or(_utilsisomorphic.transformObjectId)).optional()
});
